import {BaseTerms} from "../../infrastructure/models/base-terms";

export class LivePenaltiesModuleTerms extends BaseTerms {
  PENALTY_POPUP_LIVE = "Live";
  PENALTY_POPUP_TOP_PENALTY_KICKERS = "Top Penalty Kickers";
  PENALTY_POPUP_PENALTY_AWARDED = "Penalty Awarded";
  PENALTY_SHOTS_PENALTY_CONVERSION = "";
  PENALTY_SHOTS_FAVORITE_GOAL_ZONE = "";
  PENALTY_POPUP_CLOSE = "";
  PLAYER_POPUP_PLAYER_CARD = "";
}
